import React from "react";
import { MapPin, Navigation, Clock, Phone, Mail, Map } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
export default function FindUsHere() {
  const address = "九龍九龍城區紅磡馬頭圍道37號紅磡廣場1樓98A鋪";
  const phone = "5343 0380";
  const email = "info@prospect-care.com";
  const hours = "星期一至六：09:00 - 18:00 (公眾假期除外)";
  const encodedAddress = encodeURIComponent(address);
  const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
  const appleMapsUrl = `https://maps.apple.com/?q=${encodedAddress}`;
  return <section data-section-id="128218" id="紅磡廣場門店" className="relative w-full h-[80vh] min-h-[600px] max-h-[900px] bg-background overflow-hidden flex items-center">
      {}
      <div className="absolute inset-0 w-full h-full">
        <iframe title="Studio Location Map" src={`https://maps.google.com/maps?q=${encodedAddress}&t=&z=15&ie=UTF8&iwloc=&output=embed`} className="w-full h-full border-0 grayscale opacity-60 mix-blend-multiply dark:mix-blend-screen dark:opacity-40" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" />
      </div>

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none flex flex-col items-center">
        <div className="relative flex items-center justify-center w-12 h-12 bg-background rounded-full shadow-2xl border border-primary/20">
          <MapPin className="w-6 h-6 text-primary" />
          <div className="absolute -bottom-2 w-1 h-4 bg-primary/40 rounded-full" />
        </div>
        <div className="w-4 h-1 bg-primary/20 rounded-[100%] mt-2 blur-[2px]" />
      </div>

      {}
      <div className="container relative z-10 mx-auto px-4 md:px-6 h-full flex items-center">
        <Card className="w-full max-w-md bg-white/90 backdrop-blur-2xl border-purple-100 shadow-2xl rounded-3xl">
          <CardHeader className="border-b border-purple-50 pb-6">
            <CardTitle className="text-2xl font-serif tracking-tight flex items-center gap-3 text-primary">
              <span className="w-8 h-[2px] bg-primary inline-block" />
              門店位置
            </CardTitle>
          </CardHeader>
          
          <CardContent className="pt-6 space-y-6">
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <MapPin className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-foreground mb-1">親臨到訪</h4>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {address}<br />
                    <span className="text-xs text-primary/70 mt-1 block">港鐵黃埔站 A 出口步行約 8 分鐘</span>
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Clock className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-foreground mb-1">服務時間</h4>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    {hours}
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="w-5 h-5 text-primary shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-semibold text-foreground mb-1">聯絡方式</h4>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    電話：{phone}
                  </p>
                  <p className="text-muted-foreground text-sm leading-relaxed">
                    電郵：{email}
                  </p>
                </div>
              </div>
            </div>
          </CardContent>

          <CardFooter className="flex flex-col sm:flex-row gap-3 pt-2 pb-8">
            <Button asChild className="w-full rounded-full bg-primary hover:bg-primary/90 text-primary-foreground shadow-lg shadow-primary/20" variant="default">
              <Link to={googleMapsUrl} newTab>
                <Map className="w-4 h-4 mr-2" />
                Google 地圖
              </Link>
            </Button>
            <Button asChild className="w-full rounded-full border-primary/20 text-primary hover:bg-secondary/50" variant="outline">
              <Link to={appleMapsUrl} newTab>
                <Navigation className="w-4 h-4 mr-2" />
                Apple 地圖
              </Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </section>;
}